export function weekContaining(date: Date, firstWeekday: number): Date[] {
  const normalizedFirstDay = Number.isInteger(firstWeekday) && firstWeekday >= 0 && firstWeekday <= 6
    ? firstWeekday
    : 1;
  const start = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  start.setDate(start.getDate() - ((start.getDay() - normalizedFirstDay + 7) % 7));
  return Array.from({ length: 7 }, (_, index) =>
    new Date(start.getFullYear(), start.getMonth(), start.getDate() + index)
  );
}

export function weekStartTimestamp(date: Date, firstWeekday: number): number {
  return weekContaining(date, firstWeekday)[0].getTime();
}
